import { useQuery } from 'src/shared/lib/useQuery';
import { useOrg } from 'src/shared/contexts/OrgContext';
import { genQueryKey } from 'src/shared/lib/query.utils';
import { ThreadStore } from 'src/features/flows/types/threadStore.types';
import { QueryResult } from 'src/shared/types/util.types';

export function useThreadStores(integrationId?: string, threadId?: string): QueryResult<ThreadStore[]> {
  const { orgFetch, currentOrg } = useOrg();

  const queryKey = ['thread-stores', genQueryKey(currentOrg.id, integrationId!, threadId!)];

  return useQuery({
    queryKey: queryKey,
    queryFn: getData,
    enabled: !!integrationId && !!threadId,
    // Cache for 30 seconds to avoid excessive refetches
    staleTime: 30 * 1000,
    // Keep in cache for 5 minutes
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });

  async function getData() {
    const res = await orgFetch<ThreadStore[]>(
      `/api/flow/v2/threadStore?integration=${integrationId}&thread=${threadId}`,
      {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    if (!res.ok) {
      throw new Error('Failed to fetch pushed actions');
    }

    return await res.json();
  }
}
